import "./App.css";
import React, { useEffect } from "react";

function App() {
  const list = [
    { id: 1, url: "./img/1.png" },
    { id: 2, url: "./img/2.png" },
    { id: 3, url: "./img/3.png" },
    { id: 4, url: "./img/4.png" },
  ];

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <div>
      <div className="container">
        <div className="container-top-content">
          <div className="container-top">
            <img src={require("./img/logo.png")} alt="" />
            <div className="container-top-title1">AirZen</div>
            <div className="container-top-title2">Build your breath routine. Test lungs, save favorites.</div>
          </div>
        </div>
        <div className="container-content-cont">
          <div className="container-content-cont-title">Function</div>
          <div className="container-content-wrapper">
            {list.map((item, index) => {
              return (
                <img
                  className={
                    index % 2 === 0
                      ? "container-content-img-odd"
                      : "container-content-img-even"
                  }
                  style={item.id === 8 ? { top: "-151px" } : {}}
                  src={require(`./img/${item.id}.png`)}
                  alt=""
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="footer">
        <div>邮箱 : jfk51667jjs@163.com</div>
        <div>Shanghai Jiuzhu Information Technology Co., Ltd</div>
        <div>备案号：沪ICP备2021015531号-1</div>
      </div>
    </div>
  );
}

export default App;
